var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgJumpBackward = function SvgJumpBackward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.507 2.3-1.184 1.184c4.789.645 8.481 4.748 8.481 9.714 0 5.413-4.388 9.802-9.802 9.802S2.2 18.611 2.2 13.198h1.838a7.964 7.964 0 1 0 9.334-7.847l1.004 1.005-1.3 1.3-3.262-3.263L13.207 1zm-4.3 14.276H8.385v-4.332H6.672v-1.217h.293c.515 0 .895-.107 1.187-.321.282-.205.448-.526.536-.983l.019-.078h1.5zm7.011-2.366c0 1.538-1.09 2.541-2.872 2.541-1.538 0-2.647-.72-2.832-2.093l1.732-.136c.117.516.516.808 1.09.808.711 0 1.14-.448 1.14-1.08 0-.614-.41-1.072-1.14-1.072-.379 0-.7.127-.963.419l-1.635-.146.632-3.806h4.361v1.45h-3.047l-.223 1.188.029.02c.37-.273.876-.4 1.402-.4 1.372 0 2.326.876 2.326 2.307",
    clipRule: "evenodd"
  })));
};
export default SvgJumpBackward;